import React from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import CustomText from '../../components/customText/CustomText';
import TimePicker from '../../components/timePicker';
import LocationComponent from '../../components/location';
import theme from '../../constants/theme.style.js';
import NewMessageHeader from '../../components/newMessageHeader';

const styles = StyleSheet.create({
  icon: {
    width: theme.ICON_WIDTH,
    height: theme.ICON_WIDTH,
  },
  centerWrap: {
    maxWidth: 900,
    width: '100%',
    alignSelf: 'center',
  },
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: theme.GREEN_DARKER_COLOR,
  },
  detailContainer: {
    backgroundColor: theme.WHITE_COLOR,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    padding: 0,
  },
  subHeader: {
    color: theme.GREEN_DARKER_COLOR,
    marginTop: theme.CONTAINER_MARGIN * 1.5,
    marginBottom: theme.CONTAINER_MARGIN,
    fontSize: theme.FONT_SIZE_HEADLINE,
    fontWeight: 'bold',
    alignItems: 'center',
    paddingLeft: 20,
  },
});

export default class NewMessageTimeSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navigation: props.navigation,
    };
  }

  render() {
    const { navigation } = this.state;
    const { test } = this.props;

    return (
      <View style={styles.container}>
        <NewMessageHeader
          navigation={navigation}
          nextScreen="NewMessageTimeSelection"
          previousScreen="NewMessage"
          web
          testID="newMessageHeader"
        />
        <ScrollView style={styles.detailContainer}>
          <View style={styles.centerWrap}>
            <CustomText style={styles.subHeader}>Choose Time And Date:</CustomText>
            {!test && <TimePicker /> // jest has a problem with Flatpickr in TimePicker Component
            }
            <CustomText style={styles.subHeader}>Add Location:</CustomText>
            <LocationComponent />
          </View>
        </ScrollView>
      </View>
    );
  }
}
